import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';

import HistoryEntryEditTimeLeft from 'components/HistoryEntryEditTimeLeft';
import ActionButton from 'components/ActionButton';

import { childStyle } from './CommonHistoryEntryControls.less';

const CommonHistoryEntryControls = ({ time, action, children }) => (
  <Row middle="xs" end="xs">
    {time && (
      <Col xs={0} sm={8} md={9}>
        <HistoryEntryEditTimeLeft time={time} />
      </Col>
    )}
    {!time && children && (
      <Col xs={0} sm={8} md={9} className={childStyle}>
        {children}
      </Col>
    )}
    {window.__ROLE__ !== 'DOCTOR' && (
      <Col xs={12} sm={4} md={3}>
        <ActionButton localeId="dictionary.edit" border secondary condensed onClick={action} />
      </Col>
    )}
  </Row>
);

CommonHistoryEntryControls.propTypes = {
  time: PropTypes.number,
  children: PropTypes.node,
  action: PropTypes.func.isRequired,
};

export default CommonHistoryEntryControls;
